import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

const baseUrl = process.env.REACT_APP_API_HOST;
const orgs = `${baseUrl}/${apiConstants.ORGANIZATIONS}`;

export const searchZohoAccounts = async (q) => (await axios.get(`${orgs}/accounts/search`, { params: { q } })).data;
export const listOrganizations = async (params = {}) => (await axios.get(orgs, { params })).data;
export const getOrganization = async (id) => (await axios.get(`${orgs}/${id}`)).data;
export const createOrganization = async (body) => axios.post(orgs, body);
export const updateOrganization = async (id, body) => axios.put(`${orgs}/${id}`, body);
export const addSite = async (id, body) => axios.post(`${orgs}/${id}/sites`, body);
export const updateSite = async (id, siteId, body) => axios.put(`${orgs}/${id}/sites/${siteId}`, body);
export const inviteUser = async (id, body) => axios.post(`${orgs}/${id}/users/invite`, body);
export const setUserStatus = async (id, userId, status) => axios.put(`${orgs}/${id}/users/${userId}/status`, { status });
export const listAccessRequests = async (params = {}) => (await axios.get(`${orgs}/access-requests`, { params })).data;
export const updateAccessRequest = async (id, body) => axios.put(`${orgs}/access-requests/${id}`, body);

// Who owes us what, from Zoho Books.
export const getReceivables = async () => (await axios.get(`${orgs}/receivables`)).data;
export const getOrgAccount = async (id) => (await axios.get(`${orgs}/${id}/account`)).data;

// The society account book: what the CRM knows, cached. Read-only - the CRM
// is master, so there is no update call here by design.
export const getSocietyBook = async (params = {}) => (await axios.get(`${orgs}/society-book`, { params })).data;
export const getSocietyAccount = async (accountId) => (await axios.get(`${orgs}/society-book/${accountId}`)).data;
export const refreshSocietyBook = async () => (await axios.post(`${orgs}/society-book/refresh`)).data;
